import React, { useEffect, useRef, useState } from "react";

const About = () => {
  const ref = useRef(null);
  const [inView, setInView] = useState(false);
  useEffect(() => {
    const obs = new IntersectionObserver(
      ([e]) => e.isIntersecting && setInView(true),
      { threshold: 0.2 }
    );
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, []);

  return (
    <section id="o-nas" className="pt-12 md:pt-16 pb-20 md:pb-28 bg-white">
      <div
        ref={ref}
        className={`max-w-3xl mx-auto px-5 md:px-8 text-center fade-up ${
          inView ? "in-view" : ""
        }`}
      >
        <span className="eyebrow-line">O nás</span>
        <h2 className="font-heading mt-5 text-[30px] sm:text-[38px] md:text-[52px] font-bold text-[#1b2b45] leading-tight">
          Realitní a stavební společnost
        </h2>
        <p className="mt-6 text-[16px] md:text-[17px] leading-relaxed text-[#6b7385]">
          Naše vášní je měnit prostor v krásné a funkční místa pro váš život.
          Díky vlastnímu stavebnímu týmu a oddělení grafických i dispozičních
          návrhů vám do 2 měsíců od zahájení rekonstrukce vytvoříme domov –
          místo, kam se budete těšit.
        </p>
      </div>
    </section>
  );
};

export default About;
